import {Ripple} from 'primereact/ripple'
import {ReactComponent as BsRobot} from '../assets/icons/BsRobot.svg'

const StyledAiButton = ({onClick = () => {}}) => {
    return (
        <div
            className="widget-button p-2 p-button p-component border-round-2xl p-button-lg"
            onClick={onClick}>
            <BsRobot style={{width: '24px', height: '24px'}} />
            <Ripple />
        </div>
    )
}

export default StyledAiButton
